<template>
  <li class="extras-mg-pestanas">
    <nav class="extras-mg-pestanas__lista" aria-label="Vistas de la tabla">
      <a
        v-for="v in vistas"
        :key="v.id"
        class="extras-mg-pestanas__pestana"
        :class="{ 'extras-mg-pestanas__pestana--activa': view && v.id === view.id }"
        :title="v.name"
        @click.prevent="abrir(v)"
      >
        <i
          class="extras-mg-pestanas__icono"
          :class="`${v._.type.colorClass} ${v._.type.iconClass}`"
        ></i>
        <span class="extras-mg-pestanas__nombre">{{ v.name }}</span>
      </a>
      <a
        class="extras-mg-pestanas__mas"
        title="Todas las vistas y crear una nueva"
        @click.prevent="abrirSelector"
      >
        <i class="iconoir-plus"></i>
      </a>
    </nav>
  </li>
</template>

<script>
/**
 * Las vistas de la tabla como pestañas, debajo del título: la fila "Tabla
 * principal | Kanban | +" de Monday.
 *
 * No sustituye al selector de vistas de Baserow, que sigue en la barra: ahí se
 * crean, se buscan, se renombran y se borran. Esto sólo cambia de vista, que es
 * lo que se hace todos los días, y el "+" abre ese mismo selector.
 *
 * Cambia de vista igual que el core (pages/table.vue, selectedView): un
 * router.push a 'database-table' con el viewId; la base y la tabla las toma
 * vue-router de la ruta actual.
 *
 * Se cuelga de getAdditionalTableHeaderComponents(), como TituloDeTabla, y la
 * piel la saca del flujo de la barra (position: absolute) por la misma razón:
 * Baserow mide el ancho de la barra para decidir si esconde las etiquetas de
 * sus botones, y todo lo que ocupe ancho ahí cuenta.
 */
export default {
  name: 'PestanasDeVistas',
  props: {
    database: { type: Object, required: false, default: null },
    table: { type: Object, required: true },
    view: { type: Object, required: false, default: null },
    fields: { type: Array, required: false, default: () => [] },
    isPublicView: { type: Boolean, required: false, default: false },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    vistas() {
      // El store sólo guarda las vistas de la tabla abierta: es la misma lista
      // que recibe el selector del core (pages/table.vue), en su orden.
      return this.$store.getters['view/getAllOrdered']
    },
  },
  methods: {
    abrir(v) {
      if (this.view && this.view.id === v.id) {
        return
      }
      this.$router.push({ name: 'database-table', params: { viewId: v.id } })
    },
    abrirSelector() {
      // El selector de vistas del core es el primer botón de la barra.
      const boton = this.$el
        .closest('.header')
        ?.querySelector('.header__filter-item:first-child .header__filter-link')
      if (boton) {
        boton.click()
      }
    },
  },
}
</script>
